/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateDeploymentRequest = {
    allocation_pct: string;
    exchange_account_id?: (number | null);
    mode?: CreateDeploymentRequest.mode;
    parameters?: Record<string, any>;
    risk_limits?: Record<string, any>;
    strategy_version_id: number;
    symbols: Array<string>;
    timeframe: string;
};
export namespace CreateDeploymentRequest {
    export enum mode {
        PAPER = 'paper',
        LIVE = 'live',
    }
}

